/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chromecast': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M3.667 4C2.747 4 2 4.718 2 5.6v3.2h1.667V5.6h16.666v12.8h-6.666V20h6.666c.92 0 1.667-.718 1.667-1.6V5.6c0-.882-.747-1.6-1.667-1.6H3.667zM2 10.4V12c4.308 0 7.863 3.154 8.292 7.183.027.268.041.541.041.817H12c0-5.294-4.486-9.6-10-9.6zm0 3.2v1.6c2.758 0 5 2.153 5 4.8h1.667c0-3.529-2.991-6.4-6.667-6.4zm0 3.2V20h3.333c0-.849-.35-1.663-.976-2.263A3.405 3.405 0 002 16.8z" _fill="#000"/>'
  }
})
